import Tooltip from '@/ui/tooltip';
import React, { useEffect, useState, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { SVGPureIcon } from '@/ui';
import { Segmented } from 'antd';
import MindmapV2 from '@/components/mindmapV2';
import Markdown from '@/components/markdown';
import {
  atomOneDark,
  atomOneLight,
} from '@fengkx/react-syntax-highlighter/dist/esm/styles/hljs';
import { markdownToPlainText } from '@shared/utils';
import copy from 'copy-to-clipboard';
import Other from '@/common/helper/other';
import { request } from '@/common';
import EE from '@/common/event';
import Markmap from '@/components/markmap';
import { saveSvgAsPng } from '@/utils/svg';
import fullScreenModalStore from '../full-screen-modal/store';
import QrcodeShare from '../qrcode-share';
import { HelperCore } from '@/common/dependencies';

const segmentItems = [
  {
    label: '思维导图结果',
    value: 'result_mindmap',
  },
  {
    label: '源代码',
    value: 'code',
  },
  // {
  //   label: '工具参数',
  //   value: 'params',
  // },
];

const MindMap = ({ data, event, title="", cid }) => {
  const [currentVal, setCurrentVal] = useState('result_mindmap');

  const {
    share_url: shareUrl
  } = event;

  const onSegmentedChange = value => {
    setCurrentVal(value);
  };

  const prehandleMindmap = (mindmap) => {
    let ret = ""

    if(mindmap) {
      // mindmap = mindmap.replace(/\\n/g, "\n")
      mindmap = mindmap.replace(/\~/g, " ~ ")
      mindmap = mindmap.replace(/([\d]+)\*([\d]+)/g, "$1 * $2")
      mindmap = mindmap.replace(/(\n)[\s]+(#)/g, "$1$2")
      // mindmap = mindmap.replace(/(\n)[\s]+(\-)/g, "$1$2")
      mindmap = mindmap.replace(/\$.+\$/g, "")

      ret = mindmap
    }

    return ret
  }

  const svgRefCopyWrap = React.createRef();
  const svgRefCopy = React.createRef();

  const copyFile = (input = '') => {
    const plainText = markdownToPlainText(input);
    const copied = copy(plainText);
    copied && Other.toast('复制成功', 'success');
  };

  const downloadSVG = (svgElement, filename = 'image.png') => {
    const svgData = new XMLSerializer().serializeToString(svgElement);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    // 设置canvas尺寸与SVG相同
    const svgSize = svgElement.getBoundingClientRect();
    canvas.width = svgSize.width;
    canvas.height = svgSize.height;
    
    const img = new Image();
    img.onload = function() {
      ctx.drawImage(img, 0, 0);
      const pngData = canvas.toDataURL('image/png');
      
      const downloadLink = document.createElement('a');
      downloadLink.href = pngData;
      downloadLink.download = filename;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    };
    
    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));

  };

  const showModal = () => {
    EE.emit('mindmap:modal:show', {
      mindmap: data,
      page: [{title}],
    });
  };

  return (
    <div
      className={`card-mindmap w-full h-full flex flex-col relative overflow-hidden rounded-10px h-800px overflow-hidden ${currentVal == 'code' ? 'bg-[rgb(40,44,52)]' : ''}`}
    >
      <header className="pt-16px pb-8px px-24px tabs flex justify-left items-center">
        <Segmented
          options={segmentItems}
          value={currentVal}
          onChange={onSegmentedChange}
        />
        <div className="flex flex-grow"></div>
        {currentVal == 'result_mindmap' ? (
          <>
            <div 
              className={`
                h-28px box-border rounded-6px border-1px border-black
                border-opacity-16 leading-26px px-10px cursor-pointer
                hover:bg-[rgba(0,0,0,0.03)] mx-8px text-14px text-black
                flex items-center
                ${HelperCore.isPhone() ? "border-0px px-0px" : ""}
              `}
              onClick={() => {
                fullScreenModalStore.setData({
                  show: true, 
                  type: "mindmap",
                  data: {
                    content: data,
                    title: title,
                    shareUrl: shareUrl
                  }
                });
              }}
            >
              <SVGPureIcon
                name="full_screen_modal_full2"
                className={`size-16px ${!HelperCore.isPhone() ? "mr-6px" : ""}`}
              />
              {
                !HelperCore.isPhone()
                ? "全屏"
                : null
              }
            </div>
            {
              shareUrl
              ? (
                <Tooltip 
                  title={
                    HelperCore.isPhone()
                    ? null
                    : <QrcodeShare url={shareUrl} />
                  } 
                  color="white"
                  placement="bottomLeft"
                  arrow={false}
                  getPopupContainer={node => node}
                  destroyTooltipOnHide
                >
                  <div 
                    className={`
                      h-28px box-border rounded-6px border-1px border-black
                      border-opacity-16 leading-26px px-10px cursor-pointer
                      hover:bg-[rgba(0,0,0,0.03)] mr-8px text-14px text-black card-share-btn
                      flex items-center
                      ${HelperCore.isPhone() ? "border-0px px-0px" : ""}
                    `}
                    onClick={() => {
                      const copied = copy(shareUrl);
                      copied && Other.toast('复制成功', "success");
                    }}
                  >
                    <SVGPureIcon
                      name="full_screen_modal_share2"
                      className={`size-16px ${!HelperCore.isPhone() ? "mr-6px" : ""}`}
                    />
                    {
                      !HelperCore.isPhone()
                      ? "分享"
                      : null
                    }
                  </div>
                </Tooltip>
              )
              : null
            }
            <Tooltip destroyTooltipOnHide>
              <div
                className={`
                  h-28px box-border rounded-6px border-1px border-black
                  border-opacity-16 leading-26px px-10px cursor-pointer
                  hover:bg-[rgba(0,0,0,0.03)] text-14px text-black
                  flex items-center
                  ${HelperCore.isPhone() ? "border-0px px-0px" : ""}
                `}
                onClick={() => {
                  saveSvgAsPng(svgRefCopyWrap.current, title || "")
                }}
              >
                <SVGPureIcon
                  name="download"
                  className="size-18px cursor-pointer "
                />
                {
                  !HelperCore.isPhone()
                  ? "下载"
                  : null
                }
              </div>
            </Tooltip>
          </>
        ) : (
          <div
            style={{
              boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.12)',
            }}
            className="h-28px w-48px text-center leading-28px cursor-pointer rounded-6px bg-[#444] hover:bg-[#666] text-14px text-[#fff] border-1px border-[rgba(255,255,255,0.10)] mr-6px"
            onClick={() => {
              copyFile(data);
            }}
          >
            复制
          </div>
        )}
      </header>

      <div className="px-24px pr-16px mr-4px my-16px overflow-x-hidden overflow-y-auto scrollbar scrollbar-light h-full">
        {currentVal == 'result_mindmap' ? (
          <div className='size-full flex items-center'>
            <MindmapV2
              showModalContorller={false}
              wrapcls={`!border-0`}
              mindmap={data}
              title={title}
            />
          </div>
        ) : null}

        <div ref={svgRefCopyWrap} style={{
          position: "fixed",
          top: "0px",
          left: "30000px",
          padding: "32px",
          paddingBottom: "0px",
          width: "100vw",
          height: "100vh",
          boxSizing: "border-box"
        }}>
          <Markmap 
            value={prehandleMindmap(data)}
            style={{
              width: "100%",
              height: "calc(100% - 114px)"
            }} 
            ref={svgRefCopy}
            markviewConf={{ autoFit: true, zoom: true, pan: true, maxWidth: 400, spacingVertical: 20 }}
          />
          <div style={{
            width: "100%",
            height: "114px",
            position: "relative"
          }}>
            <img 
              style={{width: "205px", height: "74px", position: "absolute", right: "0px", top: "8px"}}
              src="https://p3.ssl.qhimg.com/t110b9a9301359874f5abf9b878.png"
              alt="mindmap-logo" />
          </div>
        </div>

        {currentVal == 'code' ? (
          <Markdown
            typing={false}
            text={'```text\n' + data?.trim() + '\n```'}
            hideLanguage
            highlighterConfig={{
              className: 'highlighter-box highlighter-box-dark over',
              style: atomOneDark,
              showLineNumbers: true,
            }}
            components={{}}
          />
        ) : null}
        {/* {currentVal == 'params' ? (
          <Markdown
            typing={false}
            text={'```text\n' + data.trim() + '\n```'}
            hideLanguage
            highlighterConfig={{
              className: 'highlighter-box highlighter-box-dark',
              style: atomOneDark,
              showLineNumbers: true,
            }}
            components={{}}
          />
        ) : null} */}
      </div>
    </div>
  );
};
export default MindMap;
